
import {
  useCreateCampaign,
  usePublishCampaign,
  usePublishExistingCampaign,
  useUpdateCampaign,
  useDeleteCampaign,
  useDuplicateCampaign,
  useDeactivateCampaign,
  useReactivateCampaign
} from "./mutations";

export const useCampaignMutations = (userId?: string) => {
  const createCampaign = useCreateCampaign(); // Removido userId pois não precisa mais
  const publishCampaign = usePublishCampaign(userId);
  const publishExistingCampaign = usePublishExistingCampaign(userId);
  const updateCampaign = useUpdateCampaign(userId);
  const deleteCampaign = useDeleteCampaign(userId);
  const duplicateCampaign = useDuplicateCampaign(userId);
  const deactivateCampaign = useDeactivateCampaign(userId);
  const reactivateCampaign = useReactivateCampaign(userId);

  return {
    createCampaign,
    publishCampaign,
    publishExistingCampaign,
    updateCampaign,
    deleteCampaign,
    duplicateCampaign,
    deactivateCampaign,
    reactivateCampaign,
  };
};
